document.addEventListener('DOMContentLoaded', () => {
  const roots = document.querySelectorAll('tatay-uploader-root');
  if (!roots.length) return;

  roots.forEach((root) => {
    // Evitar doble montaje
    if (root.dataset.tatayMounted === 'true') return;
    root.dataset.tatayMounted = 'true';

    const maxPhotos = parseInt(root.dataset.max, 10);
    if (!maxPhotos || maxPhotos <= 0) return;

    const CLOUD_NAME = 'dneseaey8';
    const UPLOAD_PRESET = 'tatay_orders';

    /* ---------- UI ---------- */

    const label = document.createElement('label');
    label.textContent = `Sube hasta ${maxPhotos} foto(s)`;
    label.style.fontWeight = '600';
    label.style.display = 'block';
    label.style.marginBottom = '8px';

    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    if (maxPhotos > 1) input.multiple = true;

    const thumbs = document.createElement('div');
    thumbs.style.display = 'flex';
    thumbs.style.gap = '8px';
    thumbs.style.flexWrap = 'wrap';
    thumbs.style.marginTop = '10px';

    const hiddenField = document.createElement('input');
    hiddenField.type = 'hidden';
    hiddenField.name = 'properties[Fotos del cliente]';

    root.appendChild(label);
    root.appendChild(input);
    root.appendChild(thumbs);
    root.appendChild(hiddenField);

    /* ---------- Logic ---------- */

    input.addEventListener('change', async () => {
      thumbs.innerHTML = '';
      hiddenField.value = '';

      const files = Array.from(input.files).slice(0, maxPhotos);
      if (!files.length) return;

      const uploadedUrls = [];

      for (const file of files) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', UPLOAD_PRESET);

        try {
          const res = await fetch(
            `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
            { method: 'POST', body: formData }
          );

          const data = await res.json();

          if (data.secure_url) {
            uploadedUrls.push(data.secure_url);

            const img = document.createElement('img');
            img.src = data.secure_url;
            img.style.width = '80px';
            img.style.height = '80px';
            img.style.objectFit = 'cover';
            img.style.border = '1px solid #ddd';
            img.style.borderRadius = '4px';

            thumbs.appendChild(img);
          }
        } catch (err) {
          console.error('Error subiendo imagen:', err);
        }
      }

      if (uploadedUrls.length) {
        hiddenField.value = uploadedUrls.join('\n');
      }
    });
  });
});
